import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { getOrderItems, getItemProductionProgress } from '../services/api'

const ProductionProgressContext = React.createContext({
  items: [],
  productionProgresses: [],
})

const ProductionProgressContextProvider = ({ orderId, children }) => {
  const [items, setItems] = useState([])
  const [productionProgresses, setProductionProgresses] = useState([])

  useEffect(() => {
    const _fetchOrderItems = async () => {
      const items = await getOrderItems(orderId)

      setItems(items)
    }

    if (orderId) {
      _fetchOrderItems()
    }
  }, [orderId])

  useEffect(() => {
    const _fetchItemsProgresses = async () => {
      let productionProgresses = []

      productionProgresses = await Promise.all(
          items.map(async (item) => {
            const productionProgress = await getItemProductionProgress(item.id)

            return productionProgress
          })
      )
      productionProgresses = _.flatten(productionProgresses)

      setProductionProgresses(productionProgresses)
    }

    if (!!items && items.length > 0) {
      _fetchItemsProgresses()
    } else {
      setProductionProgresses([])
    }
  }, [items])

  const values = { items, productionProgresses }

  return (
    <ProductionProgressContext.Provider value={values}>
      {children}
    </ProductionProgressContext.Provider>
  )
}

ProductionProgressContextProvider.propTypes = {
  children: PropTypes.any,
  orderId: PropTypes.string
}

export {
  ProductionProgressContext,
  ProductionProgressContextProvider
}
